import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection: React.FC = () => {
  return (
    <section className="relative overflow-hidden bg-cream-200 bg-linen">
      {/* Botanical line art — right side, more visible */}
      <div className="absolute right-0 bottom-0 w-[40%] h-[80%] pointer-events-none opacity-[0.07]" style={{ position: 'absolute', zIndex: 0 }}>
        <svg viewBox="0 0 400 600" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <path d="M200 580 Q195 500 190 420 Q185 340 195 260 Q205 180 200 100 Q195 50 200 10" stroke="#1B3A2D" strokeWidth="1.2" strokeLinecap="round"/>
          <path d="M190 420 Q140 400 100 370 Q80 355 60 330" stroke="#1B3A2D" strokeWidth="0.8" strokeLinecap="round"/>
          <path d="M190 420 Q150 410 120 395 Q100 385 85 370 Q120 390 190 420Z" fill="#1B3A2D" opacity="0.3"/>
          <path d="M195 340 Q250 310 290 270 Q310 250 330 220" stroke="#1B3A2D" strokeWidth="0.8" strokeLinecap="round"/>
          <path d="M195 340 Q240 320 270 295 Q295 275 310 255 Q280 285 195 340Z" fill="#1B3A2D" opacity="0.3"/>
          <path d="M195 260 Q140 240 100 210 Q80 195 55 170" stroke="#1B3A2D" strokeWidth="0.8" strokeLinecap="round"/>
          <path d="M195 260 Q145 245 115 225 Q90 210 70 190 Q110 220 195 260Z" fill="#1B3A2D" opacity="0.3"/>
          <path d="M200 180 Q260 150 300 110 Q320 90 340 60" stroke="#1B3A2D" strokeWidth="0.8" strokeLinecap="round"/>
          <path d="M200 180 Q250 155 280 130 Q305 110 320 85 Q290 120 200 180Z" fill="#1B3A2D" opacity="0.3"/>
          <path d="M198 500 Q150 480 110 460 Q90 448 70 430" stroke="#1B3A2D" strokeWidth="0.6" strokeLinecap="round"/>
          <path d="M198 500 Q155 485 125 470 Q100 458 85 445 Q120 465 198 500Z" fill="#1B3A2D" opacity="0.2"/>
          <circle cx="200" cy="10" r="3" fill="#1B3A2D" opacity="0.2"/>
          <circle cx="60" cy="330" r="2" fill="#1B3A2D" opacity="0.15"/>
          <circle cx="330" cy="220" r="2" fill="#1B3A2D" opacity="0.15"/>
          <circle cx="55" cy="170" r="2" fill="#1B3A2D" opacity="0.15"/>
          <circle cx="340" cy="60" r="2" fill="#1B3A2D" opacity="0.15"/>
        </svg>
      </div>

      <div className="relative section-container pt-4 sm:pt-6 lg:pt-8 pb-10 sm:pb-14 lg:pb-16">
        <div className="max-w-3xl">
          {/* Eyebrow — gold badge */}
          <div className="inline-flex items-center gap-2.5 mb-3">
            <div className="w-1.5 h-1.5 rounded-full bg-gold-400 animate-breathe" />
            <span className="text-label text-gold-700 tracking-wider uppercase">
              Premium Health
            </span>
          </div>

          {/* Headline */}
          <h1 className="font-display text-display-lg sm:text-display-xl lg:text-display-hero text-forest-800 mb-3">
            Healthcare,<br />
            <span className="text-shimmer-gold">simplified.</span>
          </h1>

          {/* Subtitle */}
          <p className="text-body-lg sm:text-xl text-warm-500 max-w-lg leading-relaxed mb-6 font-sans">
            Premium medications delivered worldwide with complete privacy. Quality you can trust, discretion guaranteed.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/shop" className="btn-primary gap-2.5 font-semibold">
              Shop Now
              <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
              </svg>
            </Link>
            <Link to="/mission" className="btn-secondary">
              Learn More
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
